import React from 'react';

export default function WeightRangeFilter({ weightMin, weightMax, onChange }) {
  return (
    <div>
      <label className="block text-xs font-medium text-text-muted mb-1">Вес (кг)</label>
      <div className="flex gap-2">
        <input
          type="number"
          value={weightMin || ''}
          onChange={e => onChange('weightMin', e.target.value || '')}
          placeholder="от"
          min="0"
          step="0.1"
          className="w-1/2 px-2.5 py-1.5 text-sm bg-app text-text-primary placeholder:text-text-disabled border border-border-default rounded-lg
                     focus:outline-none focus:ring-1 focus:ring-ring-focus"
        />
        <input
          type="number"
          value={weightMax || ''}
          onChange={e => onChange('weightMax', e.target.value || '')}
          placeholder="до"
          min="0"
          step="0.1"
          className="w-1/2 px-2.5 py-1.5 text-sm bg-app text-text-primary placeholder:text-text-disabled border border-border-default rounded-lg
                     focus:outline-none focus:ring-1 focus:ring-ring-focus"
        />
      </div>
    </div>
  );
}
